const mockLocations = [{
    city: `La Jolla`,
    latitude: 32.8781267,
    longitude: -117.226831,
}, {
    city: `Brooklyn`,
    latitude: 40.6467581,
    longitude: -74.0215371,
}, {
    city: `New York`,
    latitude: 40.7420311,
    longitude: -73.9743163,
}];

export default mockLocations;
